/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/TimesUpDialog',['pixi', 'absolute', 'absolute/stringmanager', 'util/NineSliceButton', 'util/eventhandler', 'Managers/ScaleManager', 'Arkadium/GameEngine/Core/EngineManagers', 'util/CustomWordWrapper'],
	function (PIXI, Absolute, _s, NineSliceButton, EventHandler, ScaleManager, EngineManagers, CustomWordWrapper) {
		var TimesUpDialog = function (parent) {
			this.onClose = new EventHandler();
			this.initTimesUpDialog(parent);
		};

		TimesUpDialog.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		TimesUpDialog.prototype.initTimesUpDialog = function (parent) {
			PIXI.DisplayObjectContainer.call(this);
			this.layoutType = 'large';
			this.parentToAdd = parent;
			this.buildOverlay();
			this.parentToAdd.addChild(this);
			this.popupContainer = new PIXI.DisplayObjectContainer();
			var width = Absolute.Coords.x(820),
				height = Absolute.Coords.y(350),
				graphics, overlay, icon, title, body,
				popupBkg = new PIXI.Sprite.fromFrame('warning_dialogues/_cmn_backgroundTile.png');
			overlay = new PIXI.Sprite.fromFrame('warning_dialogues/_cmn_UI2_bg_vignette.png');
			overlay.width = width;
			overlay.height = height;
			overlay.alpha = 0.6;

			graphics = new PIXI.Graphics();
			graphics.beginFill(0xfdfeff);
			graphics.lineStyle(5, 0xfdfeff);
			graphics.drawRect(0, 0, width, height);
			icon = new PIXI.Sprite.fromFrame('warning_dialogues/_cmn_popup_image_info.png');
			icon.position.set(Absolute.Coords.x(30), Absolute.Coords.y(30));
			icon.width = Absolute.Coords.x(135);
			icon.height = Absolute.Coords.y(160);
			this.icon = icon;
			this.titleFontSize = 43;
			var titleStyle = {
				font: Absolute.ScreenMetrics.getResScale() * this.titleFontSize + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff',
				tint: 0xffffff,
				align: 'left'
			};
			title = new PIXI.Text(_s('GameLoss_OutOfTime_Popup_Title'), titleStyle);
			title.position.set(Absolute.Coords.x(195), Absolute.Coords.y(20));
			this.title = title;
			this.bodyFontSize = 28;
			var bodyStyle = {
				font: Absolute.ScreenMetrics.getResScale() * this.bodyFontSize + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff',
				align: 'left'
			};
			body = new PIXI.Text(_s('GameLoss_OutOfTime_Popup_Text'), bodyStyle);
			body.position.set(Absolute.Coords.x(195), Absolute.Coords.y(100));
			this.body = body;
			var labelOptions = {
				font: Absolute.ScreenMetrics.getResScale() * 29 + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff',
				align: 'left',
				anchor: {
					x: 0.5,
					y: 0.5
				},
				x: Absolute.Coords.x(0),
				y: Absolute.Coords.y(3)
			};
			this.closeButton = new NineSliceButton(
				'warning_dialogues/popup_button_Play_click.png',
				'warning_dialogues/popup_button_Play_over.png', 'warning_dialogues/popup_button_Play.png',
				Absolute.Coords.x(335), Absolute.Coords.y(100), 25, 25, 25, 25, _s('buttons.ok').toUpperCase(), labelOptions);
			var self = this;
			this.closeButton.onClick.add(function () {
				self.onClose.handleEvent();
				ScaleManager.removeElement(self);
				this.parentToAdd.removeChild(this);
				this.parentToAdd.removeChild(this.screenOverlay);
			}.bind(this), this);
			this.popupContainer.addChild(graphics);
			this.popupContainer.addChild(popupBkg);
			this.popupContainer.addChild(overlay);
			this.popupContainer.addChild(icon);
			this.popupContainer.addChild(title);
			this.popupContainer.addChild(body);
			this.popupContainer.addChild(this.closeButton);
			this.addChild(this.popupContainer);
			this.popupContainer.visible = true;
			this.closeButton.anchor.set(0.5, 0.5);
			this.closeButton.position.set(width / 2, Absolute.Coords.y(280));
			this.initForceScaleSprite();
			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
		};

		TimesUpDialog.prototype.initForceScaleSprite = function () {
			this.forceScaleSprite = PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Up.png");
			this.forceOffsetX = Absolute.Coords.x(20);
			this.forceOffsetY = Absolute.Coords.y(20);
			this.forceScaleSprite.width = Absolute.Coords.x(835);
			this.forceScaleSprite.height = Absolute.Coords.y(365);
			this.forceScaleSprite.alpha = 0;
			this.addChild(this.forceScaleSprite);
		};

		TimesUpDialog.prototype.handleResize = function () {
			if (ScaleManager.scaleFactorX <= 0.35) {
				this.changeToSmallLayout('small');
			} else {
				this.changeToLargeLayout('large');
			}
			this.updateBodyTextCustomWrap();
			if (this.parent) this.updateTransform();
			var oldScaleX = this.scale.x, oldScaleY = this.scale.y;
			this.scale.set(1, 1);
			var initialWidth = this.width, initialHeight = this.height;
			this.scale.set(oldScaleX, oldScaleY);
			var screenScaleX = Absolute.Coords.x(1920) / ScaleManager.width,
				screenScaleY = Absolute.Coords.y(1080) / ScaleManager.height,
				roomWidth = ScaleManager.width, roomHeight = ScaleManager.height;
			this.width = initialWidth * screenScaleX;
			this.height = initialHeight * screenScaleY;
			var realWidth = this.width / screenScaleX, realHeight = this.height / screenScaleY;
			var widthToShow = initialWidth, heightToShow = initialHeight;
			var tookCare = false;
			if (realWidth > roomWidth) {
				this.width = Absolute.Coords.x(1920);
				var delta = roomWidth / widthToShow;
				this.height = ((initialHeight * screenScaleY) * delta);
				if ((this.height / screenScaleY) > roomHeight) {
					this.height = Absolute.Coords.y(1080);
					var delta = roomHeight / heightToShow;
					this.width = ((initialWidth * screenScaleX) * delta);
				}
				tookCare = true;
			}
			if (!tookCare && (realHeight > roomHeight)) {
				this.height = Absolute.Coords.y(1080);
				var delta = roomHeight / heightToShow;
				this.width = ((initialWidth * screenScaleX) * delta);
				if ((this.width / screenScaleX) > roomWidth) {
					this.width = Absolute.Coords.x(1920);
					var delta = roomWidth / widthToShow;
					this.height = ((initialHeight * screenScaleY) * delta);
				}
			}
			this.x = (EngineManagers.Display.Width * .5) - (this.width / 2) + this.forceOffsetX;
			this.y = (EngineManagers.Display.Height * .5) - (this.height / 2) + this.forceOffsetY;
		};

		TimesUpDialog.prototype.changeToSmallLayout = function (layoutType) {
			if (this.layoutType === layoutType) return;
			this.icon.visible = false;
			this.title.position.set(this.icon.x, this.icon.y);
			this.title.style.font = Absolute.ScreenMetrics.getResScale() * (this.titleFontSize + 7) + "px Arial";
			this.title.updateText();
			this.body.x = this.icon.x;
			this.body.style.font = Absolute.ScreenMetrics.getResScale() * (this.bodyFontSize + 7) + "px Arial";
			this.body.updateText();
			this.layoutType = layoutType;
		};

		TimesUpDialog.prototype.changeToLargeLayout = function (layoutType) {
			if (this.layoutType === layoutType) return;
			this.icon.visible = true;
			this.title.position.set(Absolute.Coords.x(195), Absolute.Coords.y(20));
			this.title.style.font = Absolute.ScreenMetrics.getResScale() * this.titleFontSize + "px Arial";
			this.title.updateText();
			this.body.position.set(Absolute.Coords.x(195), Absolute.Coords.y(100));
			this.body.style.font = Absolute.ScreenMetrics.getResScale() * this.bodyFontSize + "px Arial";
			this.body.updateText();
			this.layoutType = layoutType;
		};


		TimesUpDialog.prototype.buildOverlay = function () {
			this.screenOverlay = new PIXI.Graphics();
			this.screenOverlay.beginFill(0x000000);
			this.screenOverlay.drawRect(0, 0, Absolute.Coords.x(10000), Absolute.Coords.y(10000));
			this.screenOverlay.alpha = 0.8;
			this.screenOverlay.interactive = true;
			this.bindScreenOverlayInteractions();
			this.parentToAdd.addChild(this.screenOverlay);
		};

		TimesUpDialog.prototype.bindScreenOverlayInteractions = function () {
			this.screenOverlay.mouseover = function (evt) {
			};
			this.screenOverlay.mouseout = function (evt) {
			};
			this.screenOverlay.mousedown = function (evt) {
			};
			this.screenOverlay.mouseup = function (evt) {
			};
			this.screenOverlay.touchstart = function (evt) {
			};
			this.screenOverlay.touchend = function (evt) {
			};
			this.screenOverlay.touchendoutside = function (evt) {
			};
		};

		TimesUpDialog.prototype.updateBodyTextCustomWrap = function () {
			var wrapWidth = Absolute.Coords.x((this.layoutType === 'small') ? 750: 600);
			CustomWordWrapper.doTextCustomWrap(
				this.body, this.bodyFontSize * Absolute.ScreenMetrics.getResScale(),
				'', wrapWidth, Absolute.Coords.y(100)
			);
		};


		return TimesUpDialog;
	});

